import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, Observable, throwError, EMPTY } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

import { AuthStore } from './auth.store';

export const accessTokenAuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authStore = inject(AuthStore);

  return from(authStore.waitForAccessToken()).pipe(
    catchError(() => {
      authStore.logout();
      return EMPTY;
    }),
    switchMap(token => {
      const authedReq = token
        ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
        : req;

      return next(authedReq).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status !== 401) return throwError(() => error);

          return from(authStore.forceRefreshAccessToken()).pipe(
            switchMap(freshToken => {
              if (!freshToken) {
                authStore.logout();
                return throwError(() => error);
              }

              const retryReq = req.clone({
                setHeaders: { Authorization: `Bearer ${freshToken}` }
              });

              return next(retryReq).pipe(
                catchError((retryError: HttpErrorResponse) => {
                  if (retryError.status === 401) {
                    authStore.logout();
                  }
                  return throwError(() => retryError);
                })
              );
            })
          );
        })
      );
    })
  );
};
